<template>
    <div>1111</div>
</template>

<script>
  export default {
    name: "DepartmentConfig"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/DepartmentConfig/index.vue